
import React from 'react'
import { connect } from 'react-redux'
import Navigation from 'support/navigation'
import i18n from 'support/i18n'
import { showPopupDialog,
    showPopupErrorSnackbar,
    showPopupSuccessSnackbar,
} from 'support/popup_dialogs'
import { getInnovateChallengeFilterList,getInnovateChallengeListForRemoveEvaluator , getInnovateIdeaListFromChallengeForRemoveEvaluator} from 'services/innovate/challenge'
import View from './View'
import ConfirmEvaluatorDeleteChallengeModal from './components/dialogs/ConfirmEvaluatorDeleteContainer'
import ConfirmEvaluatorDeleteByIdeaListModal from './components/dialogs/ConfirmEvaluatorDeleteByIdeaListContainer'

const mapStateToProps = state => {
    return {
      userEmail: state.data.user.userEmail,
      domainLoaded: state.data.domain.dataLoaded,
      getInnovateIdeaListFromChallenge: state.data.InnovateChallenge.getIdeaListFromChallengeRemoveEvaluator,
      postReponseDataForSpecificIdeaList: state.data.InnovateChallenge.postInnovateSpecificIdeaListChallengeRemoveEvaluator,
      
       listInnovateChallengeForEvalutor: state.data.InnovateChallenge.filterListInnovateChallenge,
      challengesListIsLoading: state.data.InnovateChallenge.filterListInnovateChallengeLoading,
      
      postAfterRemoveEvalutor: state.data.InnovateChallenge.postInnovateChallengeRemoveEvaluator,
      postAfterRemoveEvalutorIsLoading: state.data.InnovateChallenge.postInnovateChallengeRemoveEvaluatorIsLoading,
      postAfterIdeaListRemoveEvalutorIsLoading: state.data.InnovateChallenge.postInnovateSpecificIdeaListChallengeRemoveEvaluatorIsLoading,
      getListIdeaListRemoveEvalutorIsLoading: state.data.InnovateChallenge.getIdeaListFromChallengeRemoveEvaluatorIsLoading,
      listCommunitesChallenge:state.data.InnovateChallenge.listInnovateCommunitesChallenge,
    }
}

const mapDispatchToProps = dispatch => {
    return {
      deleteAssignedEvaluatorIntoChallengeFn : (EvaluatorlistParams)=>{
        showPopupDialog(<ConfirmEvaluatorDeleteChallengeModal EvaluatorlistParams={EvaluatorlistParams} />, dispatch)
      },
      onDeteleSpecificIdeaListFromChallengeFn : (EvaluatorlistParamsByIdea)=>{
        showPopupDialog(<ConfirmEvaluatorDeleteByIdeaListModal EvaluatorlistParamsByIdea={EvaluatorlistParamsByIdea} />, dispatch)
      },
      getInnovateChallengeAllListForRemoveEvaluatorFn: () => {
        dispatch(getInnovateChallengeListForRemoveEvaluator())
      },
      getIdeaListFromChallengeFn: (TaggedIdeaParams) => {
        dispatch(getInnovateIdeaListFromChallengeForRemoveEvaluator(TaggedIdeaParams))
      },
      getInnovateChallengeFilterListFn: (challengeStatus, offset,limit,enableIsHackathon) => {     
          dispatch(getInnovateChallengeFilterList({challengeStatus,offset ,limit , enableIsHackathon}))
        },

    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps,
  )(View)